import {
  Box,
  Button,
  Table,
  Tbody,
  Flex,
  Input,
  Th,
  Thead,
  Tr,
  useDisclosure,
} from "@chakra-ui/react";
import { LeadTableRow } from "./LeadTableRow";
import CrmDataService from "../../services/data";
import { useContext, useEffect, useState } from "react";
import { appContext } from "../../Context/AppContext";
import { DataFilter } from "../DataFilter";
import { IoMdInformationCircle } from "react-icons/io";
import { extractAndUppercaseFirstWord } from "../../helper/helper";
import { UpdateEhcExpertModal } from "../Modals/UpdateEhcExpertModal";
import { FilterLeadModal } from "../Modals/FilterLeadModal";
import { MoonLoader } from "react-spinners";
import { MdWhatsapp } from "react-icons/md";
import { FiBookmark } from "react-icons/fi";

export const LeadTable = ({
  urlSearch,
  urlStatus,
  urlSource,
  setSearchParams,
  setAction,
  setName,
  setPhoneNumber,
  setUserId,
  setAppUserId,
  setEmailVariables,
  setFollowupLogData,
  setIsWhatsappUnavailable,
}: any) => {
  const { pageId } = useContext(appContext);
  // console.log(pageId);
  const [data, setData] = useState([]);
  // const [status, setStatus] = useState([extractAndUppercaseFirstWord(pageId)]);
  const [source, setSource] = useState(
    urlSource && urlSource === "null" ? [urlSource] : []
  );
  // console.log("urlSource", urlSource);

  const loggedInUser = localStorage.getItem("logged_in_user_id");

  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalLeads, setTotalLeads] = useState(0);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState(urlSearch || "");
  const [filters, setFilters] = useState({
    assigned_expert: "",
    budget: "",
    age:"",
    lead_age:"",
    type: "",
    assigned_for: "",
    last_followup_date: { startDate: "", endDate: "" },
  });

  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [loading, setLoading] = useState(false);

  const [modal, setModal] = useState("");

  const { isOpen, onOpen, onClose } = useDisclosure();

  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];

  const fetchData = () => {
    setLoading(true);
    let payload: any = {
      status: [
        (urlStatus && urlStatus === "null") ||
          extractAndUppercaseFirstWord(pageId),
      ],
      page: page,
      limit: pageSize,
      loggedInUser: loggedInUser,
    };
    if (source.length > 0) {
      payload["source"] = source;

      CrmDataService.getLeadsData(payload, searchQuery, filters)
        .then((res) => {
          setData(res.data.data);
          setTotalLeads(res.data.total);
          setTotalPages(res.data.totalPages);
        })
        .catch((e) => console.log(e))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handleSearch = () => {
    setLoading(true);
    let payload: any = {
      status: [extractAndUppercaseFirstWord(pageId)],
      page: page,
      limit: pageSize,
      loggedInUser: loggedInUser,
    };
    if (source.length > 0) {
      payload["source"] = source;
    }
    // console.log("payload", payload, searchQuery);
    CrmDataService.getLeadsData(payload, searchQuery, filters)
      .then((res) => {
        setData(res.data.data);
        setTotalLeads(res.data.total);
        setTotalPages(res.data.totalPages);
      })
      .catch((e) => console.log(e))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, [pageId, source, page]);

  useEffect(() => {
    setPage(1);
    setSearchParams({});
  }, [pageId]);

  return (
    <Box w="100%" overflowX="hidden">
      {loading && (
        <Box
          position="fixed"
          top={0}
          left={0}
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          backgroundColor="rgba(255, 255, 255, 0.6)"
          zIndex={10}
        >
          <MoonLoader color="#327171" size={50} />
        </Box>
      )}

      <Flex bg="#518585" justify="space-between" align="center" w="100%">
        <DataFilter
          updateSourceArray={setSource}
          func={fetchData}
          selectedFilter={urlSource}
        />

        <Flex gap={5} paddingRight={5}>
          {accessControls.includes("salesAdmin") && (
            <Button
              size="sm"
              px={2}
              py={2}
              bg="#fdb508"
              disabled={!selectedUserId}
              onClick={() => {
                setModal("changeExpert");
                onOpen();
              }}
            >
              Update Owner
            </Button>
          )}

          <Button
            size="sm"
            px={2}
            py={2}
            bg="#fdb508"
            onClick={() => {
              setModal("filterExpert");
              onOpen();
            }}
          >
            Filters
          </Button>

          {modal === "changeExpert" && (
            <UpdateEhcExpertModal
              key={selectedUserId}
              isOpen={isOpen}
              onClose={onClose}
              func={fetchData}
              id={selectedUserId}
            />
          )}

          {modal === "filterExpert" && (
            <FilterLeadModal
              isOpen={isOpen}
              onClose={onClose}
              func={fetchData}
              pageId={pageId}
              filters={filters}
              setFilters={setFilters}
            />
          )}

          <Input
            id="searchquery"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search"
            maxW="200px"
            borderRadius="md"
            borderWidth="0.5px"
            color="#518585"
            bg="white"
            _placeholder={{ color: "gray.500" }}
            borderColor="white"
            _hover={{ borderColor: "gray.200" }}
            _focus={{ borderColor: "gray.200" }}
          />

          <Button
            size="md"
            px={2}
            py={2}
            colorScheme="whiteAlpha"
            bg="#70afaf"
            onClick={() => handleSearch()}
          >
            Search
          </Button>
        </Flex>
      </Flex>
      <Box w="100%" bg="white" boxShadow="md" borderRadius="md">
        <Table variant="simple" size="sm" border="1px solid gray" layout="auto">
          <Thead bg="#70afaf">
            <Tr>
              <Th px={2} style={{ width: "200px" }}>
                Email
              </Th>
              {accessControls.includes("salesAdmin") && <Th px={2}>Owner</Th>}
              {/* <Th px={2}>Location</Th> */}
              <Th px={2}>Budget</Th>
              <Th px={2}>EHC</Th>
              <Th px={2}>Issues</Th>
              <Th px={2}>Last Followup</Th>
              {/* <Th px={2}>Sysage</Th> */}
              {/* <Th px={4}>
                <IoMdInformationCircle />
              </Th>
              <Th px={2} bg="#fdb508" borderLeft="2px solid teal">
                Status
              </Th> */}
              <Th py={4} px={0} bg="#fdb508">
                <Box display="flex" justifyContent="center" alignItems="center">
                  <MdWhatsapp size={20} color="#518585" />
                </Box>
              </Th>
              <Th py={4} px={0} bg="#fdb508">
                <Box display="flex" justifyContent="center" alignItems="center">
                  <FiBookmark size={20} color="#518585" />
                </Box>
              </Th>
              <Th py={4} px={0} bg="#fdb508">
                {/* Action */}
              </Th>
              <Th py={4} px={0} bg="#fdb508">
                {/* Unsubscribe */}
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.map((el: any) => (
              <LeadTableRow
                el={el}
                setName={setName}
                setPhoneNumber={setPhoneNumber}
                setAction={setAction}
                setSource={setSource}
                setUserId={setUserId}
                setAppUserId={setAppUserId}
                setEmailVariables={setEmailVariables}
                func={fetchData}
                page={page}
                pageId={pageId}
                appliedFilters={source}
                searchQuery={searchQuery}
                selectedUser={selectedUser}
                setSelectedUser={setSelectedUser}
                selectedUserId={selectedUserId}
                setSelectedUserId={setSelectedUserId}
                setFollowupLogData={setFollowupLogData}
                setIsWhatsappUnavailable={setIsWhatsappUnavailable}
              />
            ))}
          </Tbody>
        </Table>
      </Box>
      <div className="flex row m-0 pagination">
        <div className="col-sm-6 p-lg-0">
          <p style={{ fontSize: "16px", paddingLeft: "12px" }}>
            Showing {(page - 1) * pageSize + 1} to{" "}
            {page * pageSize > totalLeads ? totalLeads : page * pageSize} of{" "}
            {totalLeads} entries
          </p>
        </div>
        <div className="col-sm-6 p-lg-0 text-right">
          <div className="btn-group" role="group">
            <button
              type="button"
              className={
                page === 1 ? "btn action-btn disabledButton " : "btn action-btn"
              }
              onClick={() => setPage(page - 1)}
              disabled={page === 1 ? true : false}
            >
              {"<< Previous"}
            </button>
            <button type="button" className="btn action-btn selected">
              {page}
            </button>
            <button
              type="button"
              className={
                page === totalPages || totalPages === 0
                  ? "btn action-btn disabledButton "
                  : "btn action-btn"
              }
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages || totalPages === 0 ? true : false}
            >
              {"Next >>"}
            </button>
          </div>
        </div>
      </div>
    </Box>
  );
};
